var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgEmergencyExit = function SvgEmergencyExit(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    fill: "none"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M5.844 3.929c.27 0 .534.079.758.229l4.104 2.736c.368.245.61.664.61 1.139v10.67a1.368 1.368 0 0 1-2.126 1.14l-4.104-2.737a1.37 1.37 0 0 1-.61-1.139V5.297c0-.756.613-1.368 1.368-1.368m0 0h8.208c.755 0 1.368.612 1.368 1.368v2.599m0 5.472v2.6c0 .755-.613 1.367-1.368 1.367h-2.736m6.84-8.071 1.368 1.368m0 0L18.156 12m1.368-1.368h-5.472"
  })));
};
export default SvgEmergencyExit;